<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Administración Información - Consultar Información FIVI</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="RegresarAdminChv()">Volver</button>
        </div>
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="peridoPorAnioMes()" [(ngModel)]="anioConsulta">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="peridoPorAnioMes()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
        </div>
        <div class="col-auto ms-auto">
          <button type="button" class="btn btn-primary" (click)="generarExcelBaseHistorica()" [disabled]="isButtonBaseHistoricaDisabled"><i class="fas fa-download"></i> Base Histórica</button>
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-success" (click)="generarExcelInformacionConsultarInfo()">Excel</button>
        </div>
      </div>
      <div id="tabla" class="container-fluid overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
           id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">Periodo</th>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipio</th>
              <th scope="col" class="text-center">Estado cargue</th>
              <th scope="col" class="text-center">Estado fuente</th>
              <th scope="col" class="text-center">Novedad</th>
              <th scope="col" class="text-center">Consulta</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let L of ListaEstadosFuentes">
              <td scope="col" >{{L.perido}}</td>
              <td scope="col" >{{L.nit}}</td>
              <td scope="col" >{{L.razonSocial}}</td>
              <td scope="col" class="text-center">{{L.depto}}</td>
              <td scope="col" class="text-center">{{L.muni}}</td>
              <td scope="col" class="text-center">{{L.estadocargue}}</td>
              <td scope="col" class="text-center">
                <div *ngIf="L.estadofuente=='Aprobado'"><button type="button" class="btn btn-link" (click)="VerObservaciones(L.idEstInf)">{{L.estadofuente}}</button></div>
                <div *ngIf="L.estadofuente!='Aprobado'">{{L.estadofuente}}</div>
              </td>
              <td scope="col" >{{L.novedad}}</td>
              <td scope="col" class="text-center" id="opciones">
                <a *ngIf="L.estadofuente=='Aprobado'||L.estadofuente=='Cargado'" type="button" class="fas fa-download" style="color: green; margin: 2px;" (click)="ConsultarHistorico(L.idEstInf)"></a>
                <a *ngIf="L.estadofuente!='Aprobado'&&L.estadofuente!='Cargado'" type="button" class="fas fa-download" style="color: gray;  margin: 2px;  margin: 2px;"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--VER OBSERVACIONES DE APROBACION DE CARGUE-->
<button class="btn btn-primary btn-sm" #OpenModalObservacionesCargue data-toggle="modal"  data-target="#fichaindividial" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="fichaindividial" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl" style="min-width: 95%;">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Observaciones aprobación infromación</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseModalObservacionesCargue>
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-4">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="FuenteVerObservaciones.nombEntidad" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="FuenteVerObservaciones.codEnti" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Estado</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="estado" [(ngModel)]="EstadoVerObservaciones.estado" disabled/></div><!---->
            </div>
            <div class="col-4">
              <div class="row"><b>Periodo</b></div>
              <div class="row"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoModalVerOnservacion" disabled/></div><!---->
            </div>
          </div>
          <div>
            <div class="card">
              <div class="row" style="margin-top: 3px; margin-left: 10px;">
                <b>Observaciones para aprobar el cargue de información</b>
              </div>
              <br>

              <div class="row" style="margin-top: 3px; margin: auto;">
                <div class="col-4">
                  <div class="row"><b>Fecha</b></div>
                  <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="fechaAprobado" value="{{HistorialVerObservaciones.fecha}}" disabled/></div><!---->
                </div>
                <div class="col-4">
                  <div class="row"><b>Usuario</b></div>
                  <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="usuarioAprobo" value="{{HistorialVerObservaciones.usuario}}" disabled/></div><!---->
                </div>
                <div class="col-4">
                  <div class="row"><b>Rol</b></div>
                  <div class="row"><input class="form-control" type="text" name="rolAprobo" value="{{rolUsuAprobo}}" disabled/></div>
                </div>
              </div>

              <div style="text-align: center;margin-top: 3px;">
                <textarea class="form-control col-10" name="observacionaprobador" rows="4" style="margin: auto; margin-top: 3px;" [(ngModel)]="EstadoVerObservaciones.observacionSis"></textarea>
                <br>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closeModalEditarPeriodo data-dismiss="modal" style="margin: auto;">Cerrar</button>
      </div>
    </div>
  </div>
</div>

